export type NewRelicApi = {
    addPageAction?: (name: string, attrs?: Record<string, unknown>) => void;
};

export const getNewRelicApi = (): NewRelicApi | undefined => (window as unknown as { newrelic?: NewRelicApi }).newrelic;

export const afterNextPaint = (callback: () => void): void => {
    requestAnimationFrame(() => {
        requestAnimationFrame(callback);
    });
};

export const withoutUndefined = (attributes: Record<string, unknown>): Record<string, unknown> =>
    Object.fromEntries(Object.entries(attributes).filter(([, value]) => value !== undefined));
